import React from 'react'

const Clock = (props: any) => {
  return (
    <svg {...props} width="100%" height="100%" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_66)">
        <path
          d="M19 31.5C26.4558 31.5 32.5 25.4558 32.5 18C32.5 10.5442 26.4558 4.5 19 4.5C11.5442 4.5 5.5 10.5442 5.5 18C5.5 25.4558 11.5442 31.5 19 31.5Z"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 10.125V18H26.875"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Clock
